// extracted by mini-css-extract-plugin
module.exports = {"progressBar":"GlobalProgressBar_progressBar__fe2e2","nprogress-spinner":"GlobalProgressBar_nprogress-spinner__71c87"};